import { Apps } from '@f_types/index';
import { useMemo } from 'react';

const isWorkspaceInactive = (panel: { applicationWorkspaceIsActive: boolean | string }) =>
    !panel.applicationWorkspaceIsActive;

export function useMigratedUserLock(drawerPanels: any[]) {
    return useMemo(() => {
        const panelsReady = drawerPanels.length > 0;
        const qwepApp = drawerPanels.find((item) => item.applicationSysName === Apps.Qwep);
        const hasCrossdata = drawerPanels.some((item) => item.applicationSysName === Apps.Data);
        const hasAdminPanel = drawerPanels.some((item) => item.applicationSysName === Apps['Admin Panel']);

        const isMigratedLocked =
            panelsReady && Boolean(qwepApp) && isWorkspaceInactive(qwepApp) && !hasCrossdata && !hasAdminPanel;

        return { isMigratedLocked, panelsReady };
    }, [drawerPanels]);
}
